/**
 * Number fonts — authored via the `/pack` toile process (plan
 * `thinking/plans/2026_08_31_toile_pack_wiring.md` Track B), wave `toile_lettering`. Narcis file-split
 * shape (Track A): one module per pack, `registry.ts` assembles them into `livePacks`.
 */
import {tagline, chips, type ToilePack} from './data'

export const numberFontsPack: ToilePack = {
    slug: 'number-fonts',
    category: 'illustration',
    name: 'Number fonts',
    tagline: tagline('pieces', 'themes', 'styles'),
    chips: chips('themes', 'styles'),
    ratio: {w: 832, h: 1216},
    readings: [
        {key: 'styles', label: 'Style sampler', subject: 'a sheet with the digits "0123456789" written in six bands, serif, sans-serif, script, stencil, blackletter and art deco, one style per band'},
        {key: 'tattoo', label: 'Date for a tattoo', subject: 'a sheet with the date "14.08.2019" written four times in four fine-line styles, script, typewriter, roman serif and a thin sans-serif'},
        {key: 'house', label: 'House number', subject: 'the house number "27" large in the center of the page in an elegant serif with a thin rectangular border'},
    ],
    styles: [
        {key: 'fine', label: 'Fine line', style: 'thin monoline numerals with even hairline strokes', palette: 'black ink only', framing: 'the chart filling the page inside an even white margin'},
        {key: 'bold', label: 'Bold', style: 'heavy bold numerals with strong solid strokes', palette: 'black ink only', framing: 'the chart filling the page inside an even white margin'},
        {key: 'ornate', label: 'Decorative', style: 'decorative numerals with swashes, serifs and small flourishes', palette: 'black ink only', framing: 'the chart filling the page inside an even white margin'},
    ],
    directions: ['a year', 'a phone', 'roman'],
    directionHint: 'try: a year',
    seo: {
        title: 'Number Fonts: Digits 0 to 9 in Many Hands',
        metaDescription: 'Nine number font sheets: the digits 0 to 9 in serif, script and blackletter, a tattoo date and a house number.',
        h1: 'Number fonts: the digits 0 to 9 in many hands, a date, a house number',
        tagline: 'Numerals in fine line, bold and decorative strokes, black on white.',
        intro: 'Number fonts show the digits 0 to 9 in many hands, for a house number, a jersey, a tattoo of a date or a cake topper. The nine sheets give a style sampler from serif to blackletter, a date in four fine-line styles, and the house number 27 in an elegant serif. Each comes in fine line, heavy bold or decorative swashes, black on white. Ask for a year, a phone number or Roman numerals.',
        useCases: [
            'a house number on a door',
            'a jersey number',
            'a tattoo design of a date',
            'a cake topper',
        ],
        faq: [
            {q: 'Which number styles are shown?', a: 'The sampler shows serif, sans-serif, script, stencil and blackletter digits. The other sheets show fine-line, bold and decorative numerals.'},
            {q: 'Can I get a date for a tattoo?', a: 'The date sheet writes 14.08.2019 four times in four fine-line styles. Other dates are a request.'},
            {q: 'What is the difference between fine line, bold and decorative?', a: 'Fine line has thin, even strokes. Bold has heavy, solid strokes. Decorative adds swashes, serifs and small flourishes.'},
            {q: 'Are these black on white?', a: 'Yes. All nine sheets are black on white.'},
        ],
    },
}
